import { ClassFilter } from "../../js/cookie-settings/DocSearchSettings";

export enum ClassFilterMappingType
{
  Any,
  All
}

export class ClassFilterMapping
{
  classFilter:ClassFilter;
  inheritanceMatcher:RegExp;
  classMatcher:RegExp;
  mappingType:ClassFilterMappingType;
}

export class ClassFilterMatcher
{
  static matchers:ClassFilterMapping[] = 
  [
    { 
      classFilter:ClassFilter.All, 
      inheritanceMatcher: null, classMatcher: null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Editor,
      inheritanceMatcher: /^(Node|Resource)$/, classMatcher: null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter._2D, 
      inheritanceMatcher: /^(Node2D)$/, classMatcher: null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter._3D, 
      inheritanceMatcher: /^(Node3D)$/, classMatcher: null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Control,
      inheritanceMatcher: /^(Control)$/, classMatcher: null, mappingType:ClassFilterMappingType.All
    },
    

    { 
      classFilter:ClassFilter.Node, 
      inheritanceMatcher: /^(Node)$/, classMatcher: null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Resource,
      inheritanceMatcher: /^(Resource)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Audio,
      inheritanceMatcher: /^(AudioEffect|AudioNode)$/, classMatcher:/Audio/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Action,
      inheritanceMatcher: /^(Action)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Logic,
      inheritanceMatcher: /^(Selector|Condition|OnReady|OnProcess|OnPhysicsProcess|IterateActions|SceneCondition|ActionList|ActionSequence|OnCollision|OnTick|Once|ConditionalAction|Parallel|RepeatSequence|EvaluateSelector)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Sensor,
      inheritanceMatcher: /^(Sensor|SensorManager)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.UI, 
      inheritanceMatcher: /^(Resource|Node|UIImageType)$/, classMatcher:/^(UIImage|UIInputInfo|UIText|UIWrapper|UIRegion|UIStyle|UI|UINumber|UIColor|UISettings|UISelector|UISelectorStyle|UISelectorFlag|UISelectorFlagEntry)$/, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Procedural,
      inheritanceMatcher: /^(Scatterer|MeshModifier)$/, classMatcher:/^(MeshGeometry|Baker|MultiBaker|MeshCombiner|TextureCombiner|TextureMerger|Cuboid|Tube|GrassPatch|LeafMesh|BillboardTree)$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Camera,
      inheritanceMatcher: /^(CameraManager|VirtualCamera|PostProcessVolumeEffect|CameraEffect|CameraSlotSelector)$/, classMatcher:/^(VirtualCamera3DSlot|CameraTargetOffset|PlayCameraEffect|CameraEffectTargetAnimationCurve|CameraEffectTargetType)$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Timeline,
      inheritanceMatcher: /^(Duration)$/, classMatcher:/^(Delay|DelayedList|TimeLine|TimeLineManager|ModulateTimeLineSpeed|SetTimeLineSpeed|TimeLineEvent|TimeLineSpan)$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Shaders,
      inheritanceMatcher: /^(ShaderGenerator|ShaderPropertyName|ShaderProperty|CustomMaterial|CSShaderClassGenerator)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Rendering,
      inheritanceMatcher: /^(CompositorEffect|RDObject|RDGraphNode)$/, classMatcher:/^(RDContext|RDComputeList|RDPushConstants|RDTextureFormats|RDGraph)$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Locales,
      inheritanceMatcher: /^(LocalizedString)$/, classMatcher:/^(UIText|LocaleCode|LocaleLabel3D|LocaleManager|LocaleTextEntry)$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.Math,
      inheritanceMatcher: /^(AABB|float|int|Vector2|Vector2i|Vector3|Vector3i|Vector4|Vector4i|Rect2|Rect2i|Transform2D|Transform3D|Geometry2D|Geometry3D|MathX|Math2D|Math3D|FFT|Bezier|QuadraticBezier|CubicBezier|RationalCubicBezier|BernsteinPolynom|BinomialCoefficient|Box2|Box3|Capsule2|Capsule3|Circle|Convex2|Curve2|Curve3|CustomCurve3|Distance3|LerpCurve3|Line2|Line3|Overlap3D|Path2|Plane3|Pose|Ray3|SAT2|SAT3|Shape2|Sphere|SplineCurve|SplineCurveCreator|Triangle2|Triangle3)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Structures,
      inheritanceMatcher: /^(Grid2D<T>|OcTree<T>|MapList<K,V>|Map<K,V>|QueueList<T>|MultiMap<K1,K2,V>|TreeWalker<N>|GraphWalker<N>|TreeIteratorType|TreeIterator<N>|NodesWalker)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    {  
      classFilter:ClassFilter.Text,
      inheritanceMatcher: /^(RegexUtility|Text|Lexer|LexerEvent|LexerMatcher|JSONParser|JSON|JSONData|JSONSerializer|JSONDeserializer|XMLNode|XMLReader)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Networking,
      inheritanceMatcher: /^(NetworkBackend|NetworkManager|NetworkMessage|NetworkMessageEvent|NetworkTransport|NetworkTransportSettings|NetworkTransportType|NetworkNode|NetMember)$/, classMatcher:null, mappingType:ClassFilterMappingType.All
    },

    { 
      classFilter:ClassFilter.Animation,
      inheritanceMatcher: /^(TweenAudio|TweenTimelineSpeed|TweenLight|TweenMaterial|TweenParticles|TweenPosition|TweenTimeCurve|TweenType|Highlight|HighlightActionType|HighlightEffect|Flash|FlashEffect|PlayCameraEffect|CameraEffect|CameraEffectTargetAnimationCurve)$/, classMatcher:/^()$/, mappingType:ClassFilterMappingType.Any
    },

    { 
      classFilter:ClassFilter.CompositorFX,
      inheritanceMatcher: /^(RokojoriCompositorEffect)$/, classMatcher:/^(RokojoriCompositorEffect)$/, mappingType:ClassFilterMappingType.Any
    }
    
  ];
}